<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">Upload Documents</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span
            class="badge"
            [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }"
          >
            {{
              stepDetails?.step_status == 0
                ? "INITIATION PENDING"
                : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container
          *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          "
        >
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <p-accordion [multiple]="false">
    <ng-container *ngFor="let vendor of vendors; let i = index">
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div
            class="rounded-top d-flex justify-content-between align-items-center gap-2 w-100"
          >
            <span class="font-bold whitespace-nowrap">{{
              vendor.vendor.name
            }}</span>
            <div class="d-flex gap-2 align-items-center">
              @if (activeIndex === i) {
              <i class="pi pi-minus"></i>
              } @else {
              <i class="pi pi-plus"></i>
              }
            </div>
          </div>
        </ng-template>

        <div class="vendor-criteria-table m-3">
          <p-table [value]="criteria" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th class="wid-5-percent">S.No</th>
                <th class="wid-65-percent">Criteria</th>
                <th class="wid-30-percent">Document</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-criteria let-rowIndex="rowIndex">
              <tr>
                <td>{{ rowIndex + 1 }}</td>
                <td>{{ criteria.name }}</td>
                <td>
                  <div class="d-flex gap-2 align-items-center">
                    <!-- File Upload -->
                    <!-- <div class="file-upload-wrapper">
                        <p-fileUpload #fileUploader [attr.data-vendor-id]="vendor.vendor.id" [attr.data-criteria]="criteria.name"
                            name="file" mode="basic" [auto]="false" [customUpload]="true" chooseLabel="Attach" [maxFileSize]="209715200"
                            accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            (onSelect)="
                                              onFileSelect($event, vendor.vendor.id, criteria.name)
                                            " (uploadHandler)="uploadFile(
                              $event,
                              vendor.vendor.id,
                              criteria.name,
                              documentMap[vendor.vendor.id]?.[criteria.name.trim().toLowerCase()]?.docId || null
                          )" *ngIf="
                                              stepDetails?.is_initiator ||
                                              stepDetails?.is_approver ||
                                              stepDetails?.is_recommender ||
                                              (stepDetails?.step_status != 'approved' &&
                                                userID == 6)
                                            " styleClass="p-button-sm p-button-outlined">
                        </p-fileUpload>
                    
                        <a class="mt-1 small" *ngIf="selectedFiles[vendor.vendor.id]?.[criteria.name.trim().toLowerCase()]">
                            {{
                            selectedFiles[vendor.vendor.id][
                            criteria.name.trim().toLowerCase()
                            ].name
                            }}
                        </a>
                    </div> -->
                    <app-upload-document></app-upload-document>
                    <p-button
                      label="Upload"
                      icon="pi pi-upload"
                      class="p-button-sm fetch-data-btn"
                      (onClick)="manualUpload(vendor.vendor.id, criteria.name)"
                      *ngIf="
                        stepDetails?.is_initiator ||
                        stepDetails?.is_approver ||
                        stepDetails?.is_recommender ||
                        (stepDetails?.step_status != 'approved' && userID == 6)
                      "
                    >
                    </p-button>

                    <a
                      *ngIf="documentMap[vendor.vendor.id]?.[criteria.name.trim().toLowerCase()]?.url && schemeType != 'rev'"
                      [href]="
                        apiUrl +
                        documentMap[vendor.vendor.id][
                          criteria.name.trim().toLowerCase()
                        ].url
                      "
                      target="_blank"
                      pTooltip="View Document"
                    >
                      <button
                        class="btn btn-sm p-button p-button-sm p-button-outlined"
                        type="button"
                      >
                        <i class="pi pi-eye"></i>
                      </button>
                    </a>
                    <a
                      *ngIf="
                        getDocUrl(vendor.vendor.id, criteria.name) &&
                        schemeType == 'rev'
                      "
                      [href]="
                        apiUrl + getDocUrl(vendor.vendor.id, criteria.name)
                      "
                      target="_blank"
                      pTooltip="View Document"
                    >
                      <button
                        class="btn btn-sm p-button p-button-sm p-button-outlined"
                        type="button"
                      >
                        <i class="pi pi-eye"></i>
                      </button>
                    </a>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-accordionTab>
    </ng-container>
  </p-accordion>
</div>
